import { http } from "./client";

// TOTP MFA - the one MFA implementation in this codebase, reused by every
// caller that requires it (Super Admin, Temporary Role Access holders, or
// a user opting in voluntarily). Reachable two ways with the same
// endpoints: mid-login, authenticated with the short-lived MFA-setup token
// Login returns when mfa_setup_required is true (see loginApi below), or
// normally-authenticated for voluntary self-service setup.
export interface MFAStatus {
  required: boolean;
  enabled: boolean;
  enrolled_at?: string;
}

export interface MFAEnrollmentStart {
  secret: string;
  provisioning_uri: string;
}

export const mfaApi = {
  status: () => http.get<MFAStatus>("/auth/mfa/status"),
  beginEnrollment: () => http.post<MFAEnrollmentStart>("/auth/mfa/enroll"),
  confirmEnrollment: (code: string) => http.post<{ backup_codes: string[] }>("/auth/mfa/confirm", { code }),

  // Same handlers, distinct paths: gin cannot register two different
  // middleware chains (a normal session vs an MFA-setup token) on the
  // identical path - see router.go. Used only by MFASetupPanel, mid-login.
  beginSetupEnrollment: () => http.post<MFAEnrollmentStart>("/auth/mfa/setup/enroll"),
  confirmSetupEnrollment: (code: string) => http.post<{ backup_codes: string[] }>("/auth/mfa/setup/confirm", { code }),
};
